import { commitMutation, Environment } from "react-relay";
import { relayAuthEnvironment } from "@/RelayEnvironment";
import { graphql } from "relay-runtime";
import { DispoRejectBookingMutationResponse } from "@/Domains/DispositionManagement/Mutations/__generated__/DispoRejectBookingMutation.graphql";
import { BaseError } from "@/Utils/BaseError";

export default (
    id: string,
    onCompleted: (error: Error | null, result?: string | null) => void,
) => {
    // @ts-ignore
    commitMutation(relayAuthEnvironment() as Environment, {
        mutation: graphql`
            mutation DispoRejectBookingMutation($id: String!) {
                rejectBooking(id: $id) {
                    bookingId
                }
            }
        `,
        variables: {
            id: id,
        },
        onCompleted(result) {
            const res = result as DispoRejectBookingMutationResponse;
            const bookingId: string | null = res.rejectBooking.bookingId;

            if (bookingId) {
                onCompleted(null, bookingId);
                return;
            }

            throw new BaseError(
                "DispoRejectBookingMutation failed with an unexpected Error",
                {
                    context: {
                        bookingId: id,
                    },
                },
            );
        },
        onError(err) {
            onCompleted(err);
        },
    });
};
